import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { Label, HiddenInput, InputOverlay } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { IconWithLabel } from '../../../dataDisplay/IconWithLabel/IconWithLabel.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var sizeMap = {
  medium: 'lg',
  small: 'md'
};
/**
 * This component is internal only, it's used so CheckCard and RadioCard can share logic
 */
function ToggleCard(props) {
  var _jsx2;
  var _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    title = props.title,
    type = props.type,
    subtitle = props.subtitle,
    icon = props.icon,
    alignment = props.alignment,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    restProps = __rest(props, ["invalid", "title", "type", "subtitle", "icon", "alignment", "size"]);
  return /*#__PURE__*/jsxs(Label, {
    $invalid: invalid,
    $alignment: alignment,
    $size: size,
    children: [/*#__PURE__*/jsx(IconWithLabel, {
      truncate: false,
      size: sizeMap[size],
      title: title,
      subtitle: subtitle,
      alignment: alignment,
      children: icon
    }), /*#__PURE__*/jsx(HiddenInput, _extends({
      type: type
    }, restProps)), /*#__PURE__*/jsx(InputOverlay, {
      $type: type,
      $invalid: invalid,
      $alignment: alignment,
      children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
        icon: "check",
        $size: 12,
        $color: "gray.0"
      }, _jsx2["icon"] = faCheck, _jsx2))
    })]
  });
}

export { ToggleCard };
